/* eslint-disable react-native-a11y/has-valid-accessibility-ignores-invert-colors */
import React, { FunctionComponent, useContext } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import { CareNavigatorsSquare as imageMobile, CareNavigatorsSquareDesktop as imageWeb } from '../../assets'
import { LyraSelectCareNavigator } from '../../assets/microsite'
import { IS_WEB } from '../../constants'
import { ProductTypeContext, tID } from '../../utils'
import { Image } from '../image/Image'

const LYRA_SELECT_CARE_NAV_IMG_ASPECT_RATIO = 603 / 616

type PathwaysCareNavigatorIllustrationProps = {
  width?: number
  height?: number
}

const ImageContainer = styled(Image)<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

export const PathwaysCareNavigatorIllustration: FunctionComponent<PathwaysCareNavigatorIllustrationProps> = ({
  width = 201,
  ...props
}) => {
  let height = width
  const { isLyraSelect } = useContext(ProductTypeContext)

  const imageSource = isLyraSelect
    ? LyraSelectCareNavigator
    : ((IS_WEB ? imageWeb : imageMobile) as ImageSourcePropType)

  height = isLyraSelect ? width / LYRA_SELECT_CARE_NAV_IMG_ASPECT_RATIO : height

  return (
    <ImageContainer
      width={width}
      height={height}
      testID={`${tID('LiveChatIllustrationIcon')}`}
      source={imageSource}
      {...props}
    />
  )
}
